import React from "react";
import { PieceInfoGroupProps } from "./pieceInfoGroup";
import PerformanceDisplay from "../../../components/piece/performanceDisplay";


export default function PerformancesPieceInfoGroup(props: PieceInfoGroupProps) {
    console.log(props.piece.performances);
    if(props.piece.performances.length === 0) return <></>;
    return <>
        <h4>Performances</h4>
        {Array.from(props.piece.performances).map((performance, index) => (
            <PerformanceDisplay key={index} performance={performance} />
        ))}
    </>;
}